import { Component, inject, resource, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { BookingInfoOverlayRef } from './booking-info-overlay.ref';
import { IBbitPlaceBookingMetaResponse, IBbitPlaceBookingRequestApprovalRequest } from '@bbitgmbh/bbit.utils';
import { PlaceBookingService } from '../booking.service';
import { LoadingComponent } from '../../helper/loading/loading.component';

export enum PlaceBookingStepInput {
  FILE = 'file',
  OPTIONAL_MULTI_FILE = 'optional-multi-file',
  TERMS = 'terms',
  SUBMIT = 'submit',
}

@Component({
  selector: 'app-booking-info-overlay',
  templateUrl: './booking-info-overlay.component.html',
  styleUrl: './booking-info-overlay.component.scss',
  imports: [NgIcon, FormsModule, I18nPipe, LoadingComponent],
})
export class BookingInfoOverlayComponent {
  public displayMode = signal<'isLoading' | 'loggedOut' | 'notAllowedToBook' | 'hasPendingApprovalRequest'>('isLoading');

  private _service = inject(PlaceBookingService);
  public meta = resource<IBbitPlaceBookingMetaResponse | undefined, void>({
    loader: async () => {
      if (!this._website.getProfile()) {
        this.displayMode.set('loggedOut');
        return;
      }
      const meta = await this._service.getMeta();
      if (meta.hasPendingApprovalRequest) {
        this.displayMode.set('hasPendingApprovalRequest');
      } else if (!meta.isAllowedToBook) {
        this.displayMode.set('notAllowedToBook');
      }
      return meta;
    },
  });

  constructor(
    private _overlayRef: BookingInfoOverlayRef,
    private _website: BbitWebsiteService,
  ) {}

  login(): void {
    this._website.login();
  }

  close(): void {
    this._overlayRef.close();
  }

  public async requestApproval(): Promise<void> {
    const body: IBbitPlaceBookingRequestApprovalRequest = {};
    const result = await fetch(`${this._website.getBlApiUrl()}/placeBooking/requestApproval`, {
      method: 'POST',
      headers: {
        Authorization: `${this._website.getAccessToken()}`,
      },
      body: JSON.stringify(body),
    });
    if (!result.ok) {
      throw new Error("Couldn't submit data");
    }
    this.meta.reload();
  }
}
